import { ChipArrayField } from 'admin/fields/ChipArrayField';
import { DateField, NumberField, Show, SimpleShowLayout, TextField } from 'react-admin';

import { USER_ROLES } from './userUtils';

export const UserShow: React.FC = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <NumberField label="Id" source="id" />
        <TextField label="Meno" source="name" />
        <TextField label="Priezvisko" source="surname" />
        <TextField label="E-mail" source="email" />
        <TextField label="Tel." source="phoneNumber" />
        <ChipArrayField choices={USER_ROLES} label="Role" sortable={false} source="roles" />
        <DateField label="Dátum vytvorenia" locales="sk" showTime={true} source="creationTimestamp" />
        <DateField label="Dátum zmeny" locales="sk" showTime={true} source="updateTimestamp" />
      </SimpleShowLayout>
    </Show>
  );
};
